import pptxgen from "pptxgenjs";

import type { NonDeletedExcalidrawElement } from "@excalidraw/element/types";

import { exportToCanvas } from "./export";

import type { AppState, UIAppState } from "../types";

export const exportToPpt = async (
  elements: readonly NonDeletedExcalidrawElement[],
  appState: UIAppState,
  files: any,
): Promise<Blob | null> => {
  const selectedPapers = elements.filter(
    (el) =>
      appState.selectedElementIds[el.id] &&
      el.customData?.isPapel &&
      !el.isDeleted &&
      el.customData?.formato === "PPT",
  );

  const elementsToExport = elements.filter((el) => {
    if (el.isDeleted) {
      return false;
    }
    if (selectedPapers.some((p) => p.id === el.id)) {
      return true;
    }
    if (el.groupIds && el.groupIds.length > 0) {
      return selectedPapers.some(
        (p) =>
          p.groupIds &&
          p.groupIds.length > 0 &&
          el.groupIds.some((id) => p.groupIds!.includes(id)),
      );
    }
    return false;
  });

  if (elementsToExport.length === 0 || selectedPapers.length === 0) {
    return null;
  }

  const pres = new pptxgen();
  pres.layout = "LAYOUT_16x9";

  for (let i = 0; i < selectedPapers.length; i++) {
    const papel = selectedPapers[i];
    const exportScale = 3;
    const canvas = await exportToCanvas(
      elementsToExport,
      { ...appState, exportScale } as unknown as AppState,
      files,
      {
        exportBackground: true,
        exportPadding: 0,
        viewBackgroundColor: appState.viewBackgroundColor,
        exportingFrame: papel as any,
      },
    );

    const dataUrl = canvas.toDataURL("image/png");

    const slide = pres.addSlide();
    const bgColors = ["#ffffff", "white", "transparent"];
    const bgColor = appState.viewBackgroundColor || "#ffffff";
    if (!bgColors.includes(bgColor.toLowerCase())) {
      slide.background = { color: bgColor.replace("#", "") };
    } else {
      slide.background = { color: "FFFFFF" };
    }

    slide.addImage({ data: dataUrl, x: 0, y: 0, w: "100%", h: "100%" });
  }

  const arrayBuffer = (await pres.write({
    outputType: "arraybuffer",
  })) as ArrayBuffer;
  return new Blob([arrayBuffer], {
    type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  });
};
